import { defineStore } from "pinia";

export const useUrlParameters = defineStore('url_parameters', {
  state: () => ({
    url_parameters: [],
  }),
  getters: {
    getParameters: (state) => {
      if (state.url_parameters.length) {
        return state.url_parameters;
      }

      const cookie = getCookie("url_parameters");
      if (cookie) {
        return JSON.parse(cookie);
      }

      return [];
    },
  },
  actions: {
    setParameters() {
      let data = {};
      new URLSearchParams(window.location.search).forEach((value, key) => {
        data[key] = value;
      });
      if (!Object.keys(data).length) {
        return;
      }

      this.url_parameters = data;
      console.log(data);
      setCookie("url_parameters", JSON.stringify(data), 90);
    },
  },
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
